import { Box, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputForm from "../forms/inputForm";
import { useAppDispatch } from "../../../store";
import { useEffect, useState } from "react";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import DatePickerForm from "../forms/datePickerForm";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import SelectForm from "../forms/selectFormm";

const schema = yup.object({
  title: yup.string().required(),
});

const PricingConfigSearch = ({ params, setParams }: any) => {
  const [searchFilterDebounced, setSearchFilterDebounced] = useState("");
  const [productName, setProductName] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");
  const [userActive, setUserActive] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
  } = useForm<{
    productName: string;
    lastUpdate: string;
    status: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      productName: "",
      lastUpdate: "",
      status: ""
    },
  });

  const optSelect = [
    {
      label: "ACTIVE",
      value: "ACTIVE",
    },
    {
      label: "INACTIVE",
      value: "INACTIVE",
    },
  ];

  const handleProductName = (e: string) => { setProductName(e); };
  const handleLastUpdate = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    setLastUpdate(NewDate);
  };
  const handleStatusSelect = (e: any) => { 
    if(e === null ){
      setUserActive('')  
    } else {
      setUserActive(e.value);
    }
  };

  useDebouncedEffect(() => setSearchFilterDebounced(productName), [productName], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(lastUpdate), [lastUpdate], 500); 
  useDebouncedEffect(() => setSearchFilterDebounced(userActive), [userActive], 500); 

  useEffect(() => {
    setParams({
      ...params,
      product_name: productName,
      updateFrom: lastUpdate,
      status: userActive, 
    });
  }, [searchFilterDebounced]);
  

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem", flex: 1 }}>
        <InputForm
          name="productName"
          errors={errors}
          control={control}
          required
          placeholder="Product Name"
          maxLength={100}
          isLoading={false}
          onChange={handleProductName}
        />
        <DatePickerForm
          name="lastUpdate"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Last Update"
          disabled={false}
          isLoading={false}
          required
          onChange={handleLastUpdate}
        />
        <SelectForm 
          name="status"
          defaultValue={1}
          options={optSelect}
          placeholder="Status"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          isClear
          sxFL={{ backgroundColor: "red" }}
          onChangeForm={handleStatusSelect}
        />
        <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/pricing-config/create")}
            sx={{ marginBottom: "0px", marginTop: "8px", height: '40px', width: '200px' }}
          >
            <AddIcon /> Create Pricing
          </Button>
      </Box>
    </Box>
  );
};

export default PricingConfigSearch;
